import {  getCurrentDay, getCurrentMonth, getCurrentYear } from '@/filters';

export class ErpOrdersSearch {
    public onlyForToday: boolean;
    public day: number;
    public month: number;
    public year: number;
    public pageNumber!: number;
    public pageSize!: number;

    constructor() {
        this.onlyForToday = true;
        this.day = getCurrentDay();
        this.year = getCurrentYear();
        this.month = getCurrentMonth();
        this.pageNumber = 1;
        this.pageSize = 20;
    }
}
